/* Contact forms */
if (!customElements.get('grouped-dropdown-fields')) {
  customElements.define(
    'grouped-dropdown-fields',
    class GroupedDropdownFields extends HTMLElement {
      connectedCallback() {
        this.parentSelect = this.querySelector('[data-parent-select]');
        this.childSelect = this.querySelector('[data-child-select]');
        this.childField = this.querySelector('[data-child-field]');

        if (!this.parentSelect || !this.childSelect) return;

        this.onParentChange = this.handleParentChange.bind(this);
        this.parentSelect.addEventListener('change', this.onParentChange);
        this.handleParentChange();
      }

      disconnectedCallback() {
        if (this.parentSelect && this.onParentChange) {
          this.parentSelect.removeEventListener('change', this.onParentChange);
        }
      }

      handleParentChange() {
        const option = this.parentSelect.options[this.parentSelect.selectedIndex];
        let children = [];

        if (option?.dataset?.children) {
          try {
            children = JSON.parse(option.dataset.children);
          } catch (error) {
            children = [];
          }
        }

        this.childSelect.innerHTML = '<option value="" disabled selected></option>';

        children.forEach((value) => {
          if (!value) return;
          this.childSelect.options.add(new Option(value, value));
        });

        if (this.childField) {
          this.childField.hidden = children.length === 0;
        }

        this.childSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  );
}
/* end Contact forms */

/* Color swatches */
document.addEventListener('DOMContentLoaded', function () {
  const swatchesContainers = document.querySelectorAll('.color-swatches');
  if (!swatchesContainers.length) return;

  swatchesContainers.forEach(function (container) {
    const colorItems = container.querySelectorAll('.color-item');

    colorItems.forEach(function (item) {
      item.addEventListener('click', function (event) {
        if (event.target.closest('.close-popup-image')) return;

        const group = item.closest('.color-swatch-group-indvendig, .color-swatch-group-udvendig');
        if (group) {
          group.querySelectorAll('.color-item.selected').forEach(function (other) {
            if (other !== item) other.classList.remove('selected');
          });
        }

        container.querySelectorAll('.color-item.clicked').forEach(function (other) {
          if (other !== item) other.classList.remove('clicked');
        });

        item.classList.add('selected', 'clicked');
      });
    });

    const closeButtons = container.querySelectorAll('.color-item-popup-image .close-popup-image');
    closeButtons.forEach(function (closeBtn) {
      closeBtn.addEventListener('click', function (event) {
        event.stopPropagation();
        const parentItem = closeBtn.closest('.color-item');
        if (parentItem) parentItem.classList.remove('clicked');
      });
    });
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('.color-item')) return;

    document.querySelectorAll('.color-item.clicked').forEach(function (item) {
      item.classList.remove('clicked');
    });
  });
});
/* end Color swatches */

/* Update the variant content on variantChange event */
(function () {
    function updateVariantDescription(event) {
        var sectionId = event.data.sectionId;
        var productId = event.data.productId;
        var parsedHTML = event.data.parsedHTML;
        var source = parsedHTML.getElementById('VariantDescription-' + sectionId + '-' + productId);
        var destination = document.querySelector('#VariantDescription-' + sectionId + '-' + productId);

        if (!destination) return;

        if (!source) {
            destination.innerHTML = '';
            destination.setAttribute('hidden', '');
            return;
        }

        destination.innerHTML = source.innerHTML;

        if (source.hasAttribute('hidden')) {
            destination.setAttribute('hidden', '');
        } else {
            destination.removeAttribute('hidden');
        }
    }

    if (typeof theme !== 'undefined' && theme.pubsub) {
        theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, updateVariantDescription);
    }
})();
/* end Update the variant content on variantChange event */

/* Numeric range filters (Længde, Bredde) */
const numericRangeDisplayState = new Map();

if (!customElements.get('numeric-range-filter')) {
  customElements.define(
    'numeric-range-filter',
    class NumericRangeFilter extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.cacheElements();
        if (!this.rangeMin || !this.rangeMax) return;

        this.bindEvents();
        this.syncInputBounds();
        this.initDisplay();
      }

      get stateKey() {
        return this.sliderMinHidden?.name || null;
      }

      cacheElements() {
        this.rangeMin = this.querySelector('[data-range-min-input]');
        this.rangeMax = this.querySelector('[data-range-max-input]');
        this.numberMin = this.querySelector('[data-number-min-input]');
        this.numberMax = this.querySelector('[data-number-max-input]');
        this.track = this.querySelector('.range-wrapper');
        this.checkboxes = this.querySelectorAll('[data-filter-checkbox]');
        this.sliderMinHidden = this.querySelector('[data-slider-min-param]');
        this.sliderMaxHidden = this.querySelector('[data-slider-max-param]');
        this.emptyParam = this.querySelector('[data-empty-param]');
        this.absMin = Number(this.dataset.rangeMin);
        this.absMax = Number(this.dataset.rangeMax);
      }

      bindEvents() {
        this.rangeMin.addEventListener('input', () => this.onMinSliderInput());
        this.rangeMax.addEventListener('input', () => this.onMaxSliderInput());
        this.rangeMin.addEventListener('change', () => this.onSliderChange());
        this.rangeMax.addEventListener('change', () => this.onSliderChange());
        this.numberMin.addEventListener('focus', () => this.numberMin.select());
        this.numberMax.addEventListener('focus', () => this.numberMax.select());
        this.numberMin.addEventListener('change', () => this.onMinNumberChange());
        this.numberMax.addEventListener('change', () => this.onMaxNumberChange());
      }

      // Sync min/max attributes on all inputs to current catalog bounds
      syncInputBounds() {
        this.absMin = Number(this.dataset.rangeMin);
        this.absMax = Number(this.dataset.rangeMax);

        this.rangeMin.min = this.absMin;
        this.rangeMin.max = this.absMax;
        this.rangeMax.min = this.absMin;
        this.rangeMax.max = this.absMax;
        this.numberMin.min = this.absMin;
        this.numberMin.max = this.absMax;
        this.numberMax.min = this.absMin;
        this.numberMax.max = this.absMax;
      }

      // Update the filled track between the two thumbs
      updateTrack() {
        const min = Number(this.rangeMin.value);
        const max = Number(this.rangeMax.value);
        const span = this.absMax - this.absMin || 1;

        this.track.style.setProperty('--range-min', `${((min - this.absMin) / span) * 100}%`);
        this.track.style.setProperty('--range-max', `${((max - this.absMin) / span) * 100}%`);
      }

      clampMin(min, max) {
        return Math.max(this.absMin, Math.min(min, max));
      }

      clampMax(min, max) {
        return Math.min(this.absMax, Math.max(max, min));
      }

      getCheckboxStateKey() {
        return [...this.checkboxes]
          .filter((checkbox) => checkbox.checked)
          .map((checkbox) => checkbox.value)
          .sort()
          .join(',');
      }

      hasActiveFilter() {
        return this.getCheckboxStateKey() !== '';
      }

      saveDisplayState(min, max) {
        if (!this.stateKey) return;
        numericRangeDisplayState.set(this.stateKey, { min, max });
      }

      // Update slider UI without changing checkboxes or submitting
      setDisplay(min, max) {
        min = this.clampMin(min, max);
        max = this.clampMax(min, max);

        this.rangeMin.value = min;
        this.rangeMax.value = max;
        this.numberMin.value = min;
        this.numberMax.value = max;
        this.numberMin.max = max;
        this.numberMax.min = min;
        this.updateTrack();
      }

      getUrlSliderRange() {
        if (!this.sliderMinHidden || !this.sliderMaxHidden) return null;

        const params = new URLSearchParams(window.location.search);
        const urlMin = params.get(this.sliderMinHidden.name);
        const urlMax = params.get(this.sliderMaxHidden.name);

        if (urlMin !== null && urlMax !== null && urlMin !== '' && urlMax !== '') {
          return { min: Number(urlMin), max: Number(urlMax) };
        }

        return null;
      }

      // Thumb position: URL params > in-memory state > full range
      resolveDisplayRange() {
        const urlRange = this.getUrlSliderRange();
        if (urlRange) {
          const min = this.clampMin(urlRange.min, urlRange.max);
          const max = this.clampMax(min, urlRange.max);
          return { min, max };
        }

        const saved = this.stateKey ? numericRangeDisplayState.get(this.stateKey) : null;
        if (saved) {
          const min = this.clampMin(saved.min, saved.max);
          const max = this.clampMax(min, saved.max);
          return { min, max };
        }

        return { min: this.absMin, max: this.absMax };
      }

      resetToFullRange() {
        if (this.stateKey) numericRangeDisplayState.delete(this.stateKey);
        this.updateEmptyParam(false);
        this.setDisplay(this.absMin, this.absMax);
        this.updateSliderParams(this.absMin, this.absMax, true);
        this.checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
          if (checkbox.dataset.zeroCount === 'true') {
            checkbox.disabled = true;
          }
        });
      }

      initDisplay() {
        const urlRange = this.getUrlSliderRange();

        // Reset only when filter is cleared and URL has no slider params
        if (!urlRange && !this.hasActiveFilter()) {
          this.resetToFullRange();
          return;
        }

        const { min, max } = this.resolveDisplayRange();
        const isFullRange = min === this.absMin && max === this.absMax;
        this.setDisplay(min, max);
        this.updateSliderParams(min, max, isFullRange);
        if (!isFullRange) {
          this.saveDisplayState(min, max);
        }

        const filterKey = this.dataset.filterKey;
        if (filterKey && new URLSearchParams(window.location.search).get(`dtails_empty_${filterKey}`) === '1') {
          this.updateEmptyParam(true);
        }
      }

      updateEmptyParam(isEmptyMode) {
        if (!this.emptyParam) return;

        if (isEmptyMode) {
          this.emptyParam.value = '1';
          this.emptyParam.disabled = false;
        } else {
          this.emptyParam.value = '';
          this.emptyParam.disabled = true;
        }
      }

      isEmptyModeActive() {
        return this.emptyParam && !this.emptyParam.disabled && this.emptyParam.value === '1';
      }

      applyCheckboxesForRange(min, max, isFullRange) {
        if (isFullRange) {
          this.checkboxes.forEach((checkbox) => {
            checkbox.checked = false;
            if (checkbox.dataset.zeroCount === 'true') {
              checkbox.disabled = true;
            }
          });
          return { isEmptyMode: false };
        }

        const matching = [...this.checkboxes].filter((checkbox) => {
          const value = Number(checkbox.value);
          return value >= min && value <= max;
        });

        if (matching.length === 0) {
          this.checkboxes.forEach((checkbox) => {
            checkbox.checked = false;
          });
          return { isEmptyMode: true };
        }

        this.checkboxes.forEach((checkbox) => {
          const value = Number(checkbox.value);
          const inRange = value >= min && value <= max;

          if (inRange) {
            checkbox.checked = true;
            if (checkbox.dataset.zeroCount === 'true') {
              checkbox.disabled = false;
            }
          } else {
            checkbox.checked = false;
            if (checkbox.dataset.zeroCount === 'true') {
              checkbox.disabled = true;
            }
          }
        });

        return { isEmptyMode: false };
      }

      updateSliderParams(min, max, isFullRange) {
        if (!this.sliderMinHidden || !this.sliderMaxHidden) return;

        if (isFullRange) {
          this.sliderMinHidden.value = '';
          this.sliderMaxHidden.value = '';
          this.sliderMinHidden.disabled = true;
          this.sliderMaxHidden.disabled = true;
          if (this.stateKey) numericRangeDisplayState.delete(this.stateKey);
        } else {
          this.sliderMinHidden.value = min;
          this.sliderMaxHidden.value = max;
          this.sliderMinHidden.disabled = false;
          this.sliderMaxHidden.disabled = false;
        }
      }

      syncUrlWithoutSubmit() {
        const form = this.closest('form[is="facet-form"]');
        if (!form || !form.buildUrl || !form.hasAttribute('data-history')) return;

        const url = form.buildUrl();
        url.searchParams.delete('section_id');
        history.replaceState({}, '', url.toString());
      }

      applyRange(min, max) {
        min = this.clampMin(min, max);
        max = this.clampMax(min, max);

        const isFullRange = min === this.absMin && max === this.absMax;
        const checkboxStateBefore = this.getCheckboxStateKey();
        const wasEmptyMode = this.isEmptyModeActive();

        this.setDisplay(min, max);
        this.updateSliderParams(min, max, isFullRange);
        this.saveDisplayState(min, max);

        const { isEmptyMode } = this.applyCheckboxesForRange(min, max, isFullRange);
        this.updateEmptyParam(isEmptyMode);

        const selectionChanged = checkboxStateBefore !== this.getCheckboxStateKey();
        const emptyModeChanged = wasEmptyMode !== isEmptyMode;

        if (selectionChanged || emptyModeChanged) {
          this.closest('form')?.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (isEmptyMode) {
          this.syncUrlWithoutSubmit();
          applyNumericRangeEmptyState();
        } else {
          this.syncUrlWithoutSubmit();
        }
      }

      onMinSliderInput() {
        const max = Number(this.rangeMax.value);
        const min = this.clampMin(Number(this.rangeMin.value), max);
        this.rangeMin.value = min;
        this.numberMin.value = min;
        this.updateTrack();
      }

      onMaxSliderInput() {
        const min = Number(this.rangeMin.value);
        const max = this.clampMax(min, Number(this.rangeMax.value));
        this.rangeMax.value = max;
        this.numberMax.value = max;
        this.updateTrack();
      }

      onSliderChange() {
        this.applyRange(Number(this.rangeMin.value), Number(this.rangeMax.value));
      }

      onMinNumberChange() {
        this.applyRange(Number(this.numberMin.value), Number(this.numberMax.value));
      }

      onMaxNumberChange() {
        this.applyRange(Number(this.rangeMin.value), Number(this.numberMax.value));
      }
    }
  );
}

// Re-render all numeric range sliders from AJAX response (including the filter that triggered the change)
function refreshNumericRangeFilters(responseText) {
  const parsed = new DOMParser().parseFromString(responseText, 'text/html');

  document.querySelectorAll('numeric-range-filter').forEach((current) => {
    const filterEl = current.closest('[data-filter]');
    if (!filterEl) return;

    const index = filterEl.getAttribute('data-index');
    const updated = parsed.querySelector(`[data-filter][data-index="${index}"] numeric-range-filter`);
    if (!updated) return;

    const hiddenMin = current.querySelector('[data-slider-min-param]');
    const hiddenMax = current.querySelector('[data-slider-max-param]');
    const stateKey = hiddenMin?.name;
    const isStillActive = [...updated.querySelectorAll('[data-filter-checkbox]')].some(
      (checkbox) => checkbox.hasAttribute('checked')
    );

    const params = new URLSearchParams(window.location.search);
    const urlMin = stateKey ? params.get(stateKey) : null;
    const urlMax = hiddenMax?.name ? params.get(hiddenMax.name) : null;
    const hasUrlRange = urlMin !== null && urlMax !== null && urlMin !== '' && urlMax !== '';

    if (!isStillActive && !hasUrlRange) {
      if (stateKey) numericRangeDisplayState.delete(stateKey);
    } else if (hasUrlRange) {
      numericRangeDisplayState.set(stateKey, { min: Number(urlMin), max: Number(urlMax) });
    } else {
      const rangeMinInput = current.querySelector('[data-range-min-input]');
      const rangeMaxInput = current.querySelector('[data-range-max-input]');
      if (stateKey && rangeMinInput && rangeMaxInput) {
        numericRangeDisplayState.set(stateKey, {
          min: Number(rangeMinInput.value),
          max: Number(rangeMaxInput.value),
        });
      }
    }

    current.replaceWith(document.importNode(updated, true));
  });
}

if (typeof theme !== 'undefined' && theme.pubsub) {
  theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.facetUpdate, (event) => {
    refreshNumericRangeFilters(event.responseText);
    applyNumericRangeEmptyState();
  });
}

function hasNumericRangeEmptyMode() {
  const params = new URLSearchParams(window.location.search);
  return params.get('dtails_empty_laengde') === '1' || params.get('dtails_empty_bredde') === '1';
}

function applyNumericRangeEmptyState() {
  const container = document.getElementById('ProductGridContainer');
  if (!container) return;

  if (!hasNumericRangeEmptyMode()) return;

  const template = document.getElementById('DtailsNumericRangeEmptyTemplate');
  if (template) {
    container.innerHTML = template.innerHTML;
  }

  document.querySelectorAll('results-count').forEach((el) => {
    el.textContent = '0';
  });

  const productCount = document.getElementById('ProductCount');
  const meta = document.getElementById('DtailsNumericRangeEmptyMeta');
  if (productCount && meta?.dataset.productCount) {
    productCount.textContent = meta.dataset.productCount;
  }
}

document.addEventListener('DOMContentLoaded', applyNumericRangeEmptyState);
/* end Numeric range filters */
